export default __webpack_public_path__ + "static/media/user.928bd4f8.svg";